import { Injectable } from '@angular/core';
import { APIURL } from 'app/shared/constants';
import { SignupData } from '../utils';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SuccessResult } from '@app/models';

type SignUpResponse = SuccessResult & { userAlreadyPresentInImAzure: boolean };

@Injectable({ providedIn: 'root' })
export class CustomerService {
  private BASE_DICTIONARY_URL = `${APIURL}customers/`;

  constructor(private http: HttpClient) {}

  private url(endpoint: string): string {
    return `${this.BASE_DICTIONARY_URL}${endpoint}`;
  }

  async sendEmailActivationCode(firstName: string, lastName: string, languageId: string, email: string): Promise<string> {
    const url = this.url('sendEmailActivationCode');
    const body = { firstName, lastName, languageId, email };
    const response = await lastValueFrom(this.http.post<{ emailActivationCodeId: string }>(url, body));
    return response.emailActivationCodeId;
  }

  async signup(signupData: SignupData): Promise<SignUpResponse> {
    const url = this.url('signUp');
    return await lastValueFrom(this.http.post<SignUpResponse>(url, signupData));
  }
}
